import Chart from "react-google-charts";
import { Card, CardBody, Col } from "reactstrap";
 import {
  barOneChartData,
  barOneChartDataOption,
} from "../../../data/dashboard/ChartData";
import { H5 } from "../../../AbstractElements";
import CardHeaderCommon from "../../../common-elements/card-header-common/CardHeaderCommon";

const UserStatsChart = () => {
  const totalUsers = barOneChartData
    .slice(1)
    .reduce((sum, [, count]) => sum + Number(count), 0);

  return (
    <Col sm="12" xl="5" className='m-0'>
      <Card>
        <CardHeaderCommon title="User Role Distribution" />

        <CardBody className="chart-block">
          <div className="chart-overflow" style={{ overflowX: "auto" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ flex: "0 0 auto" }}>
                <Chart
                  chartType="BarChart"
                  width="300px"
                  data={barOneChartData}
                  options={barOneChartDataOption}
                />
              </div>
              <div style={{ flex: "1", minWidth: "150px" }}></div>
            </div>
            <div
              style={{
                marginTop: "10px",
                fontSize: "16px",
                fontWeight: "bold",
                color: "#333",
                textAlign: "center",
                paddingTop: "10px",
                borderTop: "1px solid #e0e0e0",
              }}
            >
                         <H5>Total Users: {totalUsers}</H5>  

            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default UserStatsChart;
